import { BabylonFileLoaderConfiguration, Engine, FollowCamera, ISceneLoaderProgressEvent, Scene, SceneLoader, Vector3 } from "@babylonjs/core";
import "@babylonjs/materials";

import * as CANNON from "cannon";

import { appendScene, runScene } from "./scenes/tools";

export class Game {
    /**
     * Defines the engine used to draw the game using Babylon.JS and WebGL.
     */
    public engine: Engine;
    /**
     * Defines the scene used to store and draw elements in the canvas.
     */
    public scene: Scene;
    
    private loadedPercent:number = 0;

    /**
     * Constructor.
     */
    public constructor() {
        let self = this;
        this.engine = new Engine(document.getElementById("renderCanvas") as HTMLCanvasElement, true);
        this.scene = new Scene(this.engine);

        //******************* start    定制 Loading 画面 */ 
        // var loaidngScreen = new CustomLoadingScreen("正在努力加载实验数据！带宽充足，无需排队！");
        // this.engine.loadingScreen = loaidngScreen;
        // this.engine.displayLoadingUI();
        //准备自定义 Loading....
        var loadingScreenDiv = window.document.getElementById("loadingScreen");  
        var loadingScreenTitle = window.document.getElementById("loadingTitle");     
        var loadingScreenPercent = window.document.getElementById("loadingScreenPercent");        
        function customLoadingScreen() {
            console.log("customLoadingScreen creation")
        }

        if(loadingScreenDiv){
            customLoadingScreen.prototype.displayLoadingUI = function () {
                console.log("customLoadingScreen loading", self.loadedPercent)
                loadingScreenTitle.innerHTML = "正在加载实验场景数据……";
                loadingScreenDiv.style.display = "block";
                loadingScreenTitle.style.display = "block";
                loadingScreenPercent.style.display = "block";
            };
            customLoadingScreen.prototype.hideLoadingUI = function () {
                console.log("customLoadingScreen hide", self.loadedPercent)
                if(self.loadedPercent>=100){
                    console.log("customLoadingScreen loaded 100%")
                    loadingScreenDiv.style.display = "none";
                    loadingScreenTitle.style.display = "none";
                    loadingScreenPercent.style.display = "none";
                }
            };
            var loadingScreen = new customLoadingScreen();
            this.engine.loadingScreen = loadingScreen;

            //this.engine.displayLoadingUI();
        }
        //this.engine.displayLoadingUI();

        //******************* end    定制 Loading 画面 */ 

        this._bindEvents();
        this._loadScene();
    }

    /**
     * Loads the first scene.
     */
    private async _loadScene(): Promise<void> {
        let self = this;
        const rootUrl = "./scenes/_assets/";

        BabylonFileLoaderConfiguration.LoaderInjectedPhysicsEngine = CANNON;

        //await appendScene(this.scene, rootUrl, "../scene/scene.babylon");

        SceneLoader.Append(rootUrl, "../scene/scene.babylon", this.scene, () => {
            //如果加载完成
            this.scene.executeWhenReady(() => {
                console.log("scene.executeWhenReady()", self.loadedPercent);
                //隐藏 LoadingUI
                this.engine.hideLoadingUI();
                // Attach camera.
                if (!this.scene.activeCamera) {
                    throw new Error("No camera defined in the scene. Please add at least one camera in the project or create one yourself in the code.");
                }
                this.scene.activeCamera.attachControl(this.engine.getRenderingCanvas(), false);

                // Run the scene to attach scripts etc.
                runScene(this.scene, rootUrl);

                // Render.
                this.engine.runRenderLoop(() => this.scene.render());
                

            });
            //
        }, (evt:ISceneLoaderProgressEvent)=>{
            console.log("ISceneLoaderProgressEvent");
            //定制每次加载进度更新
            // onProgress
            var loadedPercent = 0;
            if (evt.lengthComputable) {
                loadedPercent = Number.parseFloat((evt.loaded * 100 / evt.total).toFixed());
            } else {
                var dlCount = evt.loaded / (1024 * 1024);
                loadedPercent = Math.floor(dlCount * 100.0) / 100.0;
            }
            self.loadedPercent = loadedPercent;
            console.log('onProgress... loading:' + loadedPercent);
            // assuming "loadingScreenPercent" is an existing html element
            document.getElementById("loadingScreenPercent").innerHTML = "场景加载百分比：" + loadedPercent;
            if(loadedPercent==100){
                document.getElementById("loadingScreenPercent").innerHTML += "<br>正在加载贴图资源……";
            }

        }, (_, message) => {
            console.error(message);
        }, "babylon");



        // Attach camera.
        // if (!this.scene.activeCamera) {
        //     throw new Error("No camera defined in the scene. Please add at least one camera in the project or create one yourself in the code.");
        // }

        // this.scene.activeCamera.attachControl(this.engine.getRenderingCanvas(), true);

        // // Render.
        // this.engine.runRenderLoop(() => this.scene.render());
    }

    /**
     * Binds the required events for a full experience.
     */
    private _bindEvents(): void {
        window.addEventListener("resize", () => this.engine.resize());
    }
}
